import { useMemo } from 'react';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { ReportInternalType, ReportStatus, useAllReportsListQuery } from '@/__generated__/graphql';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state/atoms';

export const useFilteredReportsByType = (
  type: ReportInternalType,
  status: ReportStatus,
  searchTerm?: string | undefined,
  groupId?: string | undefined,
  groupName?: string | undefined
) => {
  const selectedReportFilters = useAtomValue(state.selectedReportFilters);
  const structureId = useGetStructureId();

  const selectedAssemblyTemplateFilters = useMemo(() => {
    return Object.entries(selectedReportFilters).map(([key, value]) => ({ id: key, value: value }));
  }, [selectedReportFilters]);

  const {
    data: allReportsData,
    loading,
    error,
  } = useAllReportsListQuery({
    variables: {
      input: {
        structureId,
        status,
        internalType: type,
        name: searchTerm,
        groupId: groupId,
        groupName: groupName,
        ...(type === ReportInternalType.Component && {
          selectedAssemblyTemplateFilters,
        }),
      },
    },
    fetchPolicy: 'no-cache',
  });

  const filteredReports = useMemo(() => {
    if (!allReportsData?.allReports) return [];

    return allReportsData?.allReports;
  }, [allReportsData?.allReports]);

  return {
    reports: filteredReports,
    loading,
    error,
    allReportsData,
  };
};
